import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

import { brand } from '../theme';

/**
 * Shown while the content request is in flight.
 *
 * This is the cost of a client-rendered site: the first visitor sees a spinner
 * where a server-rendered page would already have text. It is kept short and
 * on-brand rather than pretending it is not there.
 */
export default function LoadingScreen() {
	return (
		<Box
			sx={{
				minHeight: '100vh',
				display: 'grid',
				placeItems: 'center',
				backgroundColor: brand.dark,
				color: brand.textInvert,
				gap: 3,
			}}
			role="status"
			aria-live="polite"
		>
			<Box sx={{ display: 'grid', placeItems: 'center', gap: 3 }}>
				<CircularProgress sx={{ color: brand.accent }} />
				<Typography sx={{ letterSpacing: '0.18em', textTransform: 'uppercase', fontSize: '0.8rem' }}>
					Top Tile Construction
				</Typography>
			</Box>
		</Box>
	);
}
